import { buildAskFliptSystemContext } from '../../contexts/askflipt-context';

export async function executeAskFliptFanOut(prompt: string, pdfAttachments: any[]): Promise<string> {
    if (!pdfAttachments || pdfAttachments.length === 0) {
        return "";
    }

    const lowerPrompt = prompt.toLowerCase();
    const triggers = ['flashcard', 'quiz', 'study', 'test me', 'askflipt', 'flipcard'];
    
    // In Fan-Out, if the prompt is complex AND contains askflipt triggers alongside PDFs,
    // we instruct the LLM to weave interactive study elements into its broader response.
    if (triggers.some(t => lowerPrompt.includes(t))) {
        return buildAskFliptSystemContext();
    }
    
    return "";
}
